import { useContext } from "react";
import useMediaWithInitialState from "~/lib/hooks/useMediaWithInitialState";
import MobileDetectContext from "~/components/MobileDetectContext";

export default function useIsPhone() {
  const mobileDetectContext = useContext(MobileDetectContext);
  const isPhone =
    typeof window !== "undefined" ? useMediaWithInitialState("(max-width: 380px)") : mobileDetectContext.isPhone;
  return isPhone;
}
